import React from 'react';

export const NotFound404: React.FC = () => <>NotFound404</>;
